import { render, staticRenderFns } from "./IconLaughFace.vue?vue&type=template&id=25970e2c&"
import script from "./IconLaughFace.vue?vue&type=script&lang=js&"
export * from "./IconLaughFace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports